import { useMemo, useState } from 'react'
import Axios from 'axios'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import { ClientContext } from '../clientContext/ClientContext'

import { ClientProviderProps } from './ClientContextController.types'
import { requestTokenInterceptor } from './interceptors/requestInterceptors'
import { config } from '@percent/partner-dashboard/config'

const axios = Axios.create({
  headers: {
    'Content-Type': 'application/json'
  }
})

const gsAxios = Axios.create({
  baseURL: config.urls.api,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true
})

export function ClientContextController({
  children,
  client: clientOverride,
  gsClient: gsClientOverride
}: ClientProviderProps) {
  // Created once for the provider's lifetime (not per render), so the cache is
  // stable across re-renders; clearing on auth change is handled by
  // QueryCacheAuthReset rather than by throwing the client away.
  const [queryClient] = useState(() => new QueryClient({}))

  const gsClient = gsClientOverride ?? gsAxios

  useMemo(() => {
    gsClient.interceptors.request.use(axiosRequestConfig => requestTokenInterceptor(axiosRequestConfig))
  }, [])

  const clients = useMemo(() => {
    return {
      client: clientOverride ?? axios,
      gsClient
    }
  }, [])

  return (
    <ClientContext.Provider value={clients}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </ClientContext.Provider>
  )
}
